import { css } from 'styled-components';

export const SpaceNebulaSkin = css`
  background: linear-gradient(135deg, #1a2a6c 0%, #b21f1f 50%, #fdbb2d 100%);
  border: 2px solid #ffffff33;
  box-shadow: 0 0 20px #ffffff55;
  border-radius: 20px;
`;

export const SpaceNebulaWrapperSkin = css`
  background: radial-gradient(circle at center, #000 0%, #111a42 70%, #0e2b55 100%);
`;

export const SpaceNebulaLetterSkin = css<{ $isActive: boolean }>`
  color: ${props => (props.$isActive ? '#ffffff' : '#cccccc')};
  opacity: ${props => (props.$isActive ? 1 : 0.15)};
`;
